/*
 * @Author: Tina Huang
 * @Date: 2024-07-25 17:37:33
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-07-25 17:46:22
 * @Description:
 */

export default function Video(props: any) {
  const { color } = props
  return (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2691" width="40" height="40">
      <path
        d="M793.6 972.8l-563.2 0c-113.1008 0-204.8-91.6992-204.8-204.8L25.6 256c0-113.1008 91.6992-204.8 204.8-204.8l563.2 0c113.1008 0 204.8 91.6992 204.8 204.8l0 512C998.4 881.1008 906.7008 972.8 793.6 972.8zM947.2 286.72c0-101.7856-82.5344-184.32-184.32-184.32L261.12 102.4C159.3344 102.4 76.8 184.9344 76.8 286.72l0 450.56c0 101.7856 82.5344 184.32 184.32 184.32l501.76 0c101.7856 0 184.32-82.5344 184.32-184.32L947.2 286.72zM384 308.224l307.2 203.776-307.2 203.776L384 308.224z"
        fill={color || '#272636'}
        p-id="2692"
      ></path>
    </svg>
  )
}
